import React from 'react'

import Button from '../../../../components/atoms/Button2'
import ErrorToast from '../../../../components/molecules/ErrorToast'
import Checkbox from '../Checkbox'

import useStyles from './styles'

interface AddProps {
  superType: string
  type: string
  handleAdd: (data: any, opt?: any) => void
  disabled?: boolean
  children?: React.ReactNode
  checkbox?: boolean
  saving?: boolean
}
const Add: React.FC<AddProps> = ({
  superType,
  type,
  handleAdd,
  disabled,
  children,
  checkbox,
  saving
}) => {
  const [value, setValue] = React.useState('')
  const [checked, setChecked] = React.useState(false)
  const [error, setError] = React.useState(null)

  const classes = useStyles()

  const showError = React.useCallback(message => {
    setError({ err: { message } })
  }, [])

  const handleClickAdd = React.useCallback(() => {
    if (!value.length) {
      showError(`New ${superType} ${type} name cannot be empty`)
      return
    }

    if (checkbox) {
      handleAdd(value, checked)
    } else {
      handleAdd(value)
    }
    setValue('')
    setChecked(false)
  }, [value, showError, superType, type, handleAdd, checkbox, checked])

  const handleKeyDown = React.useCallback(
    e => {
      if (e.key === 'Enter') {
        handleClickAdd()
      }
    },
    [handleClickAdd]
  )

  const handleCheck = React.useCallback(() => {
    setChecked(!checked)
  }, [checked])

  return (
    <>
      <div className={classes.root}>
        {children}

        <input
          value={value}
          onChange={e => setValue(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={`New ${type} name`}
          className={classes.input}
          maxLength={type === 'category' ? 50 : 25}
        />
        {checkbox && (
          <Checkbox
            checked={checked}
            onCheck={handleCheck}
            className={classes.checkbox}
          >
            External
          </Checkbox>
        )}

        <Button
          onClick={handleClickAdd}
          loading={saving}
          disabled={disabled}
          className={classes.button}
        >
          ADD
        </Button>
      </div>

      <ErrorToast error={error} />
    </>
  )
}

export default Add
